/**
 * Utility function to conditionally join classNames together
 * Similar to classnames or clsx library
 */
export function cn(...classes: (string | undefined | null | boolean)[]): string {
  return classes
    .filter((c) => typeof c === 'string' && c.length > 0)
    .join(' ');
}
